"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M15.3 9.9H8.7V8.7h6.6v1.2zM15.3 12.6H8.7v-1.2h6.6v1.2zM8.7 15.3h6.6v-1.2H8.7v1.2z" }), "DragOutline");
//# sourceMappingURL=DragOutline.js.map